import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, vModelDynamic as _vModelDynamic, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_23 = { class: "space-y-4" }
const _hoisted_24 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 dark:border-gray-700 pb-2 gap-3" }
const _hoisted_25 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_26 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = ["type"]
const _hoisted_30 = ["title"]
const _hoisted_31 = {
  key: 0,
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_32 = {
  key: 1,
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_33 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_34 = { class: "mt-3 space-y-2" }
const _hoisted_35 = {
  key: 0,
  class: "flex items-center text-sm font-bold text-amber-600 dark:text-amber-400"
}
const _hoisted_36 = {
  key: 1,
  class: "flex items-center text-sm font-bold text-amber-600 dark:text-amber-400"
}
const _hoisted_37 = {
  key: 2,
  class: "flex items-center text-sm font-bold text-red-600 dark:text-red-400"
}
const _hoisted_38 = {
  key: 3,
  class: "flex items-center text-sm text-red-600 dark:text-red-400 font-medium"
}
const _hoisted_39 = {
  key: 4,
  class: "flex items-center text-sm text-red-600 dark:text-red-400 font-medium"
}
const _hoisted_40 = {
  key: 5,
  class: "flex items-center text-sm text-red-600 dark:text-red-400 font-medium"
}
const _hoisted_41 = {
  key: 6,
  class: "flex items-center text-sm text-green-600 dark:text-green-400 font-medium"
}
const _hoisted_42 = { class: "space-y-3 py-2" }
const _hoisted_43 = { class: "flex items-start gap-3 p-3 bg-amber-50 dark:bg-amber-900/40 rounded-lg border border-amber-200 dark:border-amber-700" }

import { ref, reactive, watch, computed } from 'vue'
import type { employee } from '@/types/employee'
import { useToastService } from '@/services/toast'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import {
  UserPen,
  AlertTriangle,
  XCircle,
  CheckCircle,
  RefreshCw
} from 'lucide-vue-next'

interface EditEmployeeFormData {
  first_name: string
  last_name: string
  middle_name: string
  email: string
  phone_number: string
  city: string
  state: string
  zip_code: string
  password: string
  password_confirmation: string
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'EditEmployee',
  props: {
    isVisible: { type: Boolean },
    employee: {}
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Emits
const emit = __emit

// Toast service
const toast = useToastService()

// Form state
const formData = reactive<EditEmployeeFormData>({
  first_name: '',
  last_name: '',
  middle_name: '',
  email: '',
  phone_number: '',
  city: '',
  state: '',
  zip_code: '',
  password: '',
  password_confirmation: '',
})

const errors = ref<Record<string, string>>({})
const isSubmitting = ref(false)
const showPassword = ref(false)
const updatePassword = ref(false)
const confirmCloseModalVisible = ref(false)

// Store original data to track changes
const originalFormData = ref<{
  first_name: string
  last_name: string
  middle_name: string
  email: string
  phone_number: string
  city: string
  state: string
  zip_code: string
}>({
  first_name: '',
  last_name: '',
  middle_name: '',
  email: '',
  phone_number: '',
  city: '',
  state: '',
  zip_code: ''
})

// Watch for employee prop changes to populate form
watch(
  () => props.employee,
  newEmployee => {
    if (newEmployee) {
      formData.first_name = newEmployee.first_name
      formData.last_name = newEmployee.last_name
      formData.middle_name = newEmployee.middle_name || ''
      formData.email = newEmployee.email
      formData.phone_number = newEmployee.phone_number || ''
      formData.city = newEmployee.city || ''
      formData.state = newEmployee.state || ''
      formData.zip_code = newEmployee.zip_code || ''
      formData.password = ''
      formData.password_confirmation = ''

      // Store original values for change detection
      originalFormData.value = {
        first_name: newEmployee.first_name,
        last_name: newEmployee.last_name,
        middle_name: newEmployee.middle_name || '',
        email: newEmployee.email,
        phone_number: newEmployee.phone_number || '',
        city: newEmployee.city || '',
        state: newEmployee.state || '',
        zip_code: newEmployee.zip_code || ''
      }

      // Reset password-related state
      updatePassword.value = false
      errors.value = {}
    }
  },
  { immediate: true }
)

// Watch updatePassword to clear password fields when disabled
watch(updatePassword, newValue => {
  if (!newValue) {
    formData.password = ''
    formData.password_confirmation = ''
  }
})

// Watch for password changes to auto-update confirmation
watch(
  () => formData.password,
  newPassword => {
    if (updatePassword.value) {
      formData.password_confirmation = newPassword
    }
  }
)

// Live validation computed properties
const isPasswordTooShort = computed(() => {
  return updatePassword.value && formData.password && formData.password.length > 0 && formData.password.length < 8
})

const isPasswordValidLength = computed(() => {
  return updatePassword.value && formData.password && formData.password.length >= 8
})

const isPasswordHasSymbol = computed(() => {
  return updatePassword.value && formData.password && /[!@#$%^&*(),.?":{}|<>_~\-+=]/.test(formData.password)
})

const isPasswordMismatch = computed(() => {
  return false
})

// Name validation computed properties
const isFirstNameEmpty = computed(() => {
  return !formData.first_name || formData.first_name.trim() === ''
})

const isLastNameEmpty = computed(() => {
  return !formData.last_name || formData.last_name.trim() === ''
})

// Email validation
const isEmailInvalid = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return formData.email && formData.email.trim() !== '' && !emailRegex.test(formData.email)
})

const isEmailEmpty = computed(() => {
  return !formData.email || formData.email.trim() === ''
})

const nameValidationMessage = computed(() => {
  if (isFirstNameEmpty.value && isLastNameEmpty.value) {
    return 'First Name and Last Name are required'
  } else if (isFirstNameEmpty.value) {
    return 'First name is required'
  } else if (isLastNameEmpty.value) {
    return 'Last name is required'
  }
  return ''
})

// Check if any form data has changed
const hasFormChanges = computed(() => {
  // Check if basic info has changed
  const basicInfoChanged = 
    formData.first_name !== originalFormData.value.first_name ||
    formData.last_name !== originalFormData.value.last_name ||
    formData.middle_name !== originalFormData.value.middle_name ||
    formData.email !== originalFormData.value.email ||
    formData.phone_number !== originalFormData.value.phone_number ||
    formData.city !== originalFormData.value.city ||
    formData.state !== originalFormData.value.state ||
    formData.zip_code !== originalFormData.value.zip_code

  // Check if password is being updated
  const passwordChanged = updatePassword.value && formData.password !== ''

  return basicInfoChanged || passwordChanged
})

// Disable submit button if no changes or form is submitting
const isSubmitDisabled = computed(() => {
  return !hasFormChanges.value || isSubmitting.value
})

// Methods
const validateForm = (): boolean => {
  errors.value = {}

  // Use the same validation logic as the live validation
  if (isFirstNameEmpty.value) {
    errors.value.first_name = 'First name is required'
  }

  if (isLastNameEmpty.value) {
    errors.value.last_name = 'Last name is required'
  }

  if (!formData.email.trim()) {
    errors.value.email = 'Email is required'
  } else if (isEmailInvalid.value) {
    errors.value.email = 'Please enter a valid email address'
  }

  // Password validation only if updating password
  if (updatePassword.value) {
    if (!formData.password) {
      errors.value.password = 'Password is required'
    } else if (formData.password.length < 8) {
      errors.value.password = 'Password must be at least 8 characters long'
    } else if (!isPasswordHasSymbol.value) {
      errors.value.password = 'Password must contain at least one symbol'
    }
  }

  return Object.keys(errors.value).length === 0
}

const handleSubmit = async () => {
  if (!validateForm() || !props.employee) return

  isSubmitting.value = true

  try {
    // Prepare the update data
    const updateData: any = {
      first_name: formData.first_name.trim(),
      last_name: formData.last_name.trim(),
      middle_name: formData.middle_name.trim() || null,
      email: formData.email.trim(),
      phone_number: formData.phone_number.trim() || null,
      city: formData.city.trim() || null,
      state: formData.state.trim() || null,
      zip_code: formData.zip_code.trim() || null
    }

    // Add password fields only if updating password
    if (updatePassword.value && formData.password) {
      updateData.password = formData.password
      updateData.password_confirmation = formData.password
    }

    // Import the API service dynamically to avoid circular imports
    const { default: api } = await import('@/services/api')

    // Call the update endpoint
    const response = await api.put(`/users/${props.employee.user_details_id}`, updateData)

    if (response.data.success) {
      // Show success toast message with different messages based on whether password was updated
      if (updatePassword.value) {
        toast.success(
          `${formData.first_name} ${formData.last_name}'s details and password have been updated.`
        )
      } else {
        toast.success(
          `${formData.first_name} ${formData.last_name}'s details have been updated.`
        )
      }

      // Reset change tracking since changes have been saved
      
      // Update originalFormData to reflect the saved changes
      originalFormData.value = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        middle_name: formData.middle_name,
        email: formData.email,
        phone_number: formData.phone_number,
        city: formData.city,
        state: formData.state,
        zip_code: formData.zip_code
      }

      // Reset password fields after successful update
      if (updatePassword.value) {
        formData.password = ''
        formData.password_confirmation = ''
        updatePassword.value = false
        showPassword.value = false
      }

      // Emit success event with updated employee data
      emit('success', response.data.data)
      closeModal()
    } else {
      throw new Error(response.data.message || 'Failed to update employee')
    }
  } catch (error: any) {
    console.error('Error updating employee:', error)

    // Handle validation errors from server
    if (error.response?.status === 422 && error.response?.data?.errors) {
      // Convert array errors to string errors
      const apiErrors = error.response.data.errors
      Object.keys(apiErrors).forEach(key => {
        errors.value[key] = Array.isArray(apiErrors[key]) ? apiErrors[key][0] : apiErrors[key]
      })
      const firstField = Object.keys(error.response.data.errors)[0]
      const firstError = error.response.data.errors[firstField][0]
      toast.error('Validation Error', firstError)
    } else {
      // Handle other errors
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to update employee'
      errors.value.general = errorMessage
      toast.error('Update Failed', errorMessage)
    }
  } finally {
    isSubmitting.value = false
  }
}

const closeModal = () => {
  // Check if there are any unsaved changes
  if (hasFormChanges.value) {
    confirmCloseModalVisible.value = true
    return
  }

  performClose()
}

const generatePassword = () => {
  // Randomize length between 10 and 12 (inclusive)
  const length = Math.floor(Math.random() * 3) + 10 // 0..2 -> 10..12
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*'
  let password = ''

  // Ensure at least one lowercase, one uppercase, one number, and one special character
  password += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]
  password += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)]
  password += '0123456789'[Math.floor(Math.random() * 10)]
  password += '!@#$%^&*'[Math.floor(Math.random() * 8)]

  // Fill the rest with random characters
  for (let i = 4; i < length; i++) {
    password += charset[Math.floor(Math.random() * charset.length)]
  }

  // Shuffle the password to randomize the position of required characters
  password = password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('')

  formData.password = password
  formData.password_confirmation = password // Auto-confirm password
}

const handleConfirmedClose = () => {
  confirmCloseModalVisible.value = false
  performClose()
}

const performClose = () => {

  // Reset form
  if (props.employee) {
    formData.first_name = props.employee.first_name
    formData.last_name = props.employee.last_name
    formData.middle_name = props.employee.middle_name || ''
    formData.email = props.employee.email
    formData.phone_number = props.employee.phone_number || ''
    formData.city = props.employee.city || ''
    formData.state = props.employee.state || ''
    formData.zip_code = props.employee.zip_code || ''
    
    // Reset original data as well
    originalFormData.value = {
      first_name: props.employee.first_name,
      last_name: props.employee.last_name,
      middle_name: props.employee.middle_name || '',
      email: props.employee.email,
      phone_number: props.employee.phone_number || '',
      city: props.employee.city || '',
      state: props.employee.state || '',
      zip_code: props.employee.zip_code || ''
    }
  }
  formData.password = ''
  formData.password_confirmation = ''

  // Reset state
  errors.value = {}
  isSubmitting.value = false
  updatePassword.value = false
  showPassword.value = false

  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseModal, {
      "is-visible": _ctx.isVisible,
      title: "Edit Employee",
      subtitle: "Update employee information",
      icon: _unref(UserPen),
      size: "2xl",
      type: "default",
      "show-footer": true,
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createVNode(BaseButton, {
          text: "Cancel",
          variant: "secondary",
          onClick: closeModal,
          disabled: isSubmitting.value
        }, null, 8, ["disabled"]),
        _createVNode(BaseButton, {
          text: "Update employee",
          variant: "primary",
          loading: isSubmitting.value,
          "loading-text": "Updating...",
          disabled: isSubmitDisabled.value,
          onClick: handleSubmit
        }, null, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleSubmit, ["prevent"]),
            class: "space-y-6"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900 dark:text-white border-b border-gray-200 dark:border-gray-700 pb-2" }, " Personal Information ", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    for: "first_name",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, [
                    _createTextVNode(" First Name "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "first_name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.first_name) = $event)),
                    type: "text",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.first_name
                          }]),
                    placeholder: "Enter first name",
                    required: ""
                  }, null, 2), [
                    [_vModelText, formData.first_name]
                  ]),
                  (errors.value.first_name)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors.value.first_name), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    for: "last_name",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, [
                    _createTextVNode(" Last Name "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "last_name",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.last_name) = $event)),
                    type: "text",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.last_name
                          }]),
                    placeholder: "Enter last name",
                    required: ""
                  }, null, 2), [
                    [_vModelText, formData.last_name]
                  ]),
                  (errors.value.last_name)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.value.last_name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", {
                    for: "middle_name",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, " Middle Name ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "middle_name",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.middle_name) = $event)),
                    type: "text",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.middle_name
                          }]),
                    placeholder: "Enter middle name (optional)"
                  }, null, 2), [
                    [_vModelText, formData.middle_name]
                  ]),
                  (errors.value.middle_name)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.value.middle_name), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", {
                    for: "email",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, [
                    _createTextVNode(" Email Address "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.email) = $event)),
                    type: "email",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.email || isEmailInvalid.value
                          }]),
                    placeholder: "Enter email address",
                    required: ""
                  }, null, 2), [
                    [_vModelText, formData.email]
                  ]),
                  (errors.value.email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value.email), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", {
                    for: "phone_number",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, " Phone Number ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "phone_number",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.phone_number) = $event)),
                    type: "tel",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.phone_number
                          }]),
                    placeholder: "Enter phone number (optional)"
                  }, null, 2), [
                    [_vModelText, formData.phone_number]
                  ]),
                  (errors.value.phone_number)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(errors.value.phone_number), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", {
                    for: "city",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, " City ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "city",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.city) = $event)),
                    type: "text",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.city
                          }]),
                    placeholder: "Enter city (optional)"
                  }, null, 2), [
                    [_vModelText, formData.city]
                  ]),
                  (errors.value.city)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value.city), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    for: "state",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, " State ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "state",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.state) = $event)),
                    type: "text",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.state
                          }]),
                    placeholder: "Enter state (optional)"
                  }, null, 2), [
                    [_vModelText, formData.state]
                  ]),
                  (errors.value.state)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(errors.value.state), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", {
                    for: "zip_code",
                    class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  }, " Zip Code ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "zip_code",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.zip_code) = $event)),
                    type: "text",
                    class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.zip_code
                          }]),
                    placeholder: "Enter zip code (optional)"
                  }, null, 2), [
                    [_vModelText, formData.zip_code]
                  ]),
                  (errors.value.zip_code)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(errors.value.zip_code), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900 dark:text-white" }, " Password Update (Optional) ", -1)),
                _createElementVNode("label", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((updatePassword).value = $event)),
                    class: "sr-only peer"
                  }, null, 512), [
                    [_vModelCheckbox, updatePassword.value]
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" }, null, -1)),
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ml-3 text-sm font-medium text-gray-900 dark:text-gray-300" }, "Update Password", -1))
                ])
              ]),
              (updatePassword.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, [
                        _createTextVNode(" New Password "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          id: "password",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.password) = $event)),
                          type: showPassword.value ? 'text' : 'password',
                          class: _normalizeClass(["block w-full px-4 py-3 pr-20 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", { 'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.password }]),
                          placeholder: "Enter new password (min 8 chars, 1 symbol)",
                          minlength: "8"
                        }, null, 10, _hoisted_29), [
                          [_vModelDynamic, formData.password]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute inset-y-0 right-10 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (showPassword.value = !showPassword.value)),
                          title: showPassword.value ? 'Hide password' : 'Show password'
                        }, [
                          (!showPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_31, [...(_cache[25] || (_cache[25] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                }, null, -1),
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_32, [...(_cache[26] || (_cache[26] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                                }, null, -1)
                              ]))]))
                        ], 8, _hoisted_30),
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors",
                          onClick: generatePassword,
                          title: "Generate secure password"
                        }, [
                          _createVNode(_unref(RefreshCw), { class: "h-5 w-5" })
                        ])
                      ]),
                      (errors.value.password)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(errors.value.password), 1))
                        : _createCommentVNode("", true),
                      _cache[28] || (_cache[28] = _createElementVNode("p", { class: "mt-2 text-xs text-gray-500 dark:text-gray-400" }, " Password must be at least 8 characters long with at least one symbol ", -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              (updatePassword.value && formData.password && formData.password.length > 0 && formData.password.length < 8)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_unref(AlertTriangle), { class: "w-4 h-4 mr-2" }),
                    _createTextVNode(" Password is too short (" + _toDisplayString(formData.password.length) + "/8 characters) ", 1)
                  ]))
                : _createCommentVNode("", true),
              (updatePassword.value && formData.password && formData.password.length >= 8 && !isPasswordHasSymbol.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createVNode(_unref(AlertTriangle), { class: "w-4 h-4 mr-2" }),
                    _cache[29] || (_cache[29] = _createTextVNode(" Password needs at least one symbol (!@#$%^&* etc.) ", -1))
                  ]))
                : _createCommentVNode("", true),
              (isPasswordMismatch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                    _cache[30] || (_cache[30] = _createTextVNode(" Passwords do not match ", -1))
                  ]))
                : _createCommentVNode("", true),
              (nameValidationMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                    _createTextVNode(" " + _toDisplayString(nameValidationMessage.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (isEmailEmpty.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                    _cache[31] || (_cache[31] = _createTextVNode(" Email address is required ", -1))
                  ]))
                : (isEmailInvalid.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                      _cache[32] || (_cache[32] = _createTextVNode(" Please enter a valid email address ", -1))
                    ]))
                  : _createCommentVNode("", true),
              (
                        !nameValidationMessage.value &&
                        !isEmailEmpty.value &&
                        !isEmailInvalid.value &&
                        (!updatePassword.value || (isPasswordValidLength.value && isPasswordHasSymbol.value))
                      )
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createVNode(_unref(CheckCircle), { class: "w-4 h-4 mr-2" }),
                    _cache[33] || (_cache[33] = _createTextVNode(" All fields are valid ", -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ]),
      _: 1
    }, 8, ["is-visible", "icon"]),
    _createVNode(BaseModal, {
      "is-visible": confirmCloseModalVisible.value,
      title: "Unsaved Changes",
      subtitle: "You have unsaved modifications",
      icon: _unref(AlertTriangle),
      size: "sm",
      type: "danger",
      "show-footer": true,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (confirmCloseModalVisible.value = false))
    }, {
      footer: _withCtx(() => [
        _createVNode(BaseButton, {
          text: "Stay",
          variant: "secondary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (confirmCloseModalVisible.value = false))
        }),
        _createVNode(BaseButton, {
          text: "Close without saving",
          variant: "primary",
          onClick: handleConfirmedClose
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_unref(AlertTriangle), { class: "w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" }),
            _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-sm text-amber-800 dark:text-amber-100 font-medium" }, [
              _createTextVNode(" Please click "),
              _createElementVNode("strong", null, "\"Update employee\""),
              _createTextVNode(" to save your changes before closing. ")
            ], -1))
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-sm text-gray-700 dark:text-gray-200 font-medium" }, " Do you want to close without saving? ", -1))
        ])
      ]),
      _: 1
    }, 8, ["is-visible", "icon"])
  ], 64))
}
}

})